var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var Twitter = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M18.4736,9.66123405 C18.4736,9.51913643 18.4736,9.3776789 18.4646,9.23686144 C19.0668988,8.77210677 19.5868133,8.1966553 20,7.53745077 C19.4383274,7.80295682 18.8424976,7.9770756 18.2324,8.0539948 C18.8748464,7.64369246 19.3556741,6.99835801 19.5854,6.2380897 C18.9812945,6.6205085 18.3203877,6.8900182 17.6312,7.03498848 C16.6772497,5.95286668 15.1614316,5.68801356 13.9337296,6.38894355 C12.7060275,7.08987354 12.071765,8.58226876 12.3866,10.0292797 C9.91213744,9.89694297 7.60668547,8.6501156 6.044,6.59909445 C5.22717365,8.09921304 5.64439273,10.0183084 6.9968,10.9817177 C6.50704472,10.9662327 6.02796762,10.8252908 5.6,10.5707868 C5.6,10.5842285 5.6,10.5983102 5.6,10.612392 C5.60040088,12.1752052 6.63305089,13.5212551 8.069,13.8307109 C7.61592176,13.9625289 7.14054835,13.981798 6.6794,13.8870379 C7.08256876,15.2244343 8.23794474,16.1406189 9.5546,16.1670005 C8.46484102,17.0806702 7.11863571,17.576665 5.7326,17.5751751 C5.48774214,17.5746736 5.24312244,17.5588579 5,17.5278092 C6.40738157,18.4913057 8.04494804,19.0023709 9.7172,19 C15.3776,19.002552 18.4736,13.9996919 18.4736,9.66123405 Z" })));
};
Twitter.displayName = 'Twitter';
export default Twitter;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Twitter.js.map